module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "picview"
  }, [_c('div', {
    staticClass: "piccontainer"
  }, _vm._l((_vm.pics), function(pic, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('a', {
      attrs: {
        "href": pic.url ? _vm.picAddr + pic.url : '',
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": pic.url ? _vm.picAddr + pic.url : ''
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "viewtext"
    }, [_c('div', {
      staticClass: "contents"
    }, [_c('div', {
      class: {
        showtext: pic.showText
      }
    }, _vm._l((pic.contents), function(content) {
      return _c('div', {
        staticClass: "content"
      }, [_vm._v(_vm._s(content))])
    }), 0)])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-8aeeee26!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PicView.vue
// module id = 304
// module chunks = 0